import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { Timer } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 9
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  return <section className="py-8 bg-charcoal text-white border-y-4 border-amber" data-id="element-42">
      <div className="container mx-auto px-4 text-center" data-id="element-43">
        <div className="flex items-center justify-center mb-3 text-amber" data-id="element-44">
          <Timer className="w-5 h-5 mr-2 animate-pulse" data-id="element-45" />
          <span className="text-sm font-bold uppercase tracking-wider" data-id="element-46">
            Precio de lanzamiento — Termina hoy
          </span>
        </div>
        <div className="flex justify-center gap-3" data-id="element-47">
          {[{
          val: timeLeft.hours,
          label: 'HS'
        }, {
          val: timeLeft.minutes,
          label: 'MIN'
        }, {
          val: timeLeft.seconds,
          label: 'SEG'
        }].map((item, i) => <Fragment key={i} data-id="element-48">
              {i > 0 && <span className="text-3xl font-black text-amber/50 self-start mt-1" data-id="element-49">
                  :
                </span>}
              <div className="flex flex-col items-center" data-id="element-50">
                <div className="bg-wood-dark w-16 h-20 rounded-lg flex items-center justify-center text-3xl font-black text-amber border border-wood-light/20" data-id="element-51">
                  {fmt(item.val)}
                </div>
                <span className="text-[10px] mt-1 text-cream/50 uppercase tracking-widest" data-id="element-52">
                  {item.label}
                </span>
              </div>
            </Fragment>)}
        </div>
      </div>
    </section>;
}